import * as React from "react";
import {colours} from "../../theme";

const DividerDashed = () => <hr style={{ border: "none", borderTop: "0.5px dashed " + colours.specialist }} />

export default DividerDashed;
